export type SortKeyOrder = "earlier" | "later"
export type ExpiredDateFlag = "expiration" | "none"

export interface Proprietary {
    id: string
    listingId: string
    memo: string
    roomTypeId: string
    totalPrice: number
    span: {
        startDate: string
        endDate: string
    }
    manualType: string
    expiration: {
        expiredDate: string
        expiredDateFlag: ExpiredDateFlag
    }
    submissionId: string
}

export const proprietaryManualTypes: { label: string; value: string }[] = [
    { label: "仮ブロック", value: "仮ブロック" },
    { label: "通常専有", value: "通常専有" },
    { label: "清掃調整", value: "清掃調整" },
    { label: "物件修繕", value: "物件修繕" },
    { label: "消防", value: "消防" },
    { label: "設営", value: "設営" },
    { label: "季節休業", value: "季節休業" },
    { label: "定期点検", value: "定期点検" },
    { label: "オーナー都合", value: "オーナー都合" }
]
export type ProprietaryManualTypes =
    | "仮ブロック"
    | "通常専有"
    | "清掃調整"
    | "物件修繕"
    | "消防"
    | "設営"
    | "季節休業"
    | "定期点検"
    | "オーナー都合"

export const convertManualTypesToRequest = (
    manualType: ProprietaryManualTypes
) => {
    return manualType === "通常専有" ? "" : manualType
}

/**
 * 専有メモの最大文字数。
 * m2m-core の proprietary.ProprietaryMemoMaxLength と DB カラム長(proprietary_records.memo)に合わせている。
 * これを超えるメモは API が memo_too_long(400)で拒否する。
 */
export const PROPRIETARY_MEMO_MAX_LENGTH = 768

/**
 * Go 側(utf8.RuneCountInString)と同じ数え方にするため、UTF-16 の長さではなくコードポイント数で数える。
 * 絵文字などサロゲートペアを 1 文字として扱う。
 */
export const countProprietaryMemoLength = (memo: string): number =>
    Array.from(memo).length

/**
 * TextField の customValidations 用。上限を超えたときだけメッセージを返す。
 */
export const validateProprietaryMemoLength = (
    memo?: string
): string | undefined => {
    const length = countProprietaryMemoLength(memo ?? "")
    return length > PROPRIETARY_MEMO_MAX_LENGTH
        ? `メモは${PROPRIETARY_MEMO_MAX_LENGTH}文字以内で入力してください（現在${length}文字）`
        : undefined
}

/**
 * TextField の helperText 用。入力中の文字数と上限を表示する。
 */
export const proprietaryMemoHelperText = ({
    value
}: {
    value?: string
}): string =>
    `${countProprietaryMemoLength(value ?? "")} / ${PROPRIETARY_MEMO_MAX_LENGTH} 文字`
